/* eslint-disable max-len */
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { ScaleInput, ScaleInputWrapper, ScaleLabelWrapper, ScaleInputLabel } from './scale.styled';
import { FormContext } from '../../../shared/contexts/form-context';
import { setUserInputOnCtrl } from '../../../form/reducer/form';
import { getNumbers } from '../../../../shared/utils';
import { ControlPropType } from '../../ctrl_proptype';

// Extract shape count from value
const getRating = (ctrl, inTable, tr, col) => {
  const value = inTable ? ctrl.value?.[tr - 1]?.[col - 1] : ctrl.value;
  return value ? parseInt(value.replace(/\D/g, ''), 10) : null;
};
const ScaleRatingSubComponent = (props) => {
  const dispatch = useDispatch();
  const { ctrl, inTable, col, tr } = props;
  const rating = getRating(ctrl, inTable, tr, col);
  const { inBuilder, inForm, currentPageNo } = useContext(FormContext);
  const scaleCount = inTable ? ctrl.table_props[col - 1].scale_count : ctrl.props.scale_count;
  const [firstLabel, secondLabel] = inTable ? ctrl.table_props[col - 1].options : ctrl.props.options;
  const showScaleNumbers = inTable ? ctrl.table_props[col - 1].show_numbers : ctrl.props.show_numbers;
  const inlineClassName = inTable
    ? `${ctrl.table_props[col - 1].inline ? '' : 'col'}`
    : `${ctrl.props.inline ? '' : 'col'}`;

  const saveUpdatedCtrl = (newValue) => {
    dispatch(
      setUserInputOnCtrl({
        newValue,
        isValid: true,
        property: 'value',
        page: currentPageNo - 1,
        ctrlId: ctrl.internal_id,
        ...(inTable && { tr: tr - 1, col: col - 1 }),
      })
    );
  };

  const handleClick = (scale) => {
    if (!inForm) return;
    if (rating === scale) saveUpdatedCtrl(null);
  };

  const handleChange = (scale) => {
    if (!inForm) return;
    const newRatingString = `Option ${scale}`;
    saveUpdatedCtrl(rating !== scale ? newRatingString : null);
  };

  return (
    <ScaleInputWrapper className={inlineClassName} id={inTable ? `fpl-${col}-${tr}` : `fpl-${ctrl.internal_id}`}>
      <ScaleLabelWrapper className={`${!inBuilder ? 'notInBuilder' : ''}`}>{firstLabel}</ScaleLabelWrapper>

      {getNumbers(scaleCount).map((scale, idx) => (
        <ScaleInputLabel tabIndex="0" key={scale} className={inlineClassName}>
          {showScaleNumbers && <span>{idx + 1}</span>}
          <ScaleInput
            type="radio"
            value={`Option ${scale}`}
            checked={scale === rating}
            onClick={() => handleClick(scale)}
            onChange={() => handleChange(scale)}
            className={`${!ctrl.props.inline ? 'col' : ''}`}
            id={!inTable ? `fpl-${ctrl.internal_id}-${idx}` : `fpl-${ctrl.internal_id}-${idx}-${tr}-${col}`}
            name={!inTable ? `fpl-${ctrl.internal_id}-${idx}` : `fpl-${ctrl.internal_id}-${idx}-${tr}-${col}`}
          />
        </ScaleInputLabel>
      ))}

      <ScaleLabelWrapper className={`${!inBuilder ? 'notInBuilder' : ''}`}>{secondLabel}</ScaleLabelWrapper>
    </ScaleInputWrapper>
  );
};

ScaleRatingSubComponent.defaultProps = {
  tr: null,
  col: null,
  inTable: false,
};

ScaleRatingSubComponent.propTypes = {
  tr: PropTypes.number,
  col: PropTypes.number,
  inTable: PropTypes.bool,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};

export default ScaleRatingSubComponent;
